export default "__VITE_ASSET__yQ5Mw_tp$C5jgqb_o_VSHg__";